import { render, staticRenderFns } from "./ModalEditTeam.vue?vue&type=template&id=1b9bbceb&scoped=true"
import script from "./ModalEditTeam.vue?vue&type=script&lang=js"
export * from "./ModalEditTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9bbceb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b9bbceb')) {
      api.createRecord('1b9bbceb', component.options)
    } else {
      api.reload('1b9bbceb', component.options)
    }
    module.hot.accept("./ModalEditTeam.vue?vue&type=template&id=1b9bbceb&scoped=true", function () {
      api.rerender('1b9bbceb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/team/ModalEditTeam.vue"
export default component.exports